import { createInstance, dateReviver } from '@/api';
import { PublicationClient, PublicationStatistics } from '@/api/frontoffice/clients';
import { defineStore } from 'pinia';

export interface PublicationStatisticsStoreState {
    loading: boolean;
    statistics: PublicationStatistics;
}

export const client = new PublicationClient('', createInstance(), dateReviver);

export const usePublicationStatisticsStore = defineStore('publications-publications-statistics-store', {
    state: (): PublicationStatisticsStoreState => ({
        loading: false,
        statistics: null
    }),
    getters: {},
    actions: {
        async getPublicationStatistics(): Promise<void> {
            this.loading = true;
            try {
                const response = await client.getPublicationStatistics();
                this.statistics = response;
            } catch (error) {
            } finally {
                this.loading = false;
            }
        },
        clear() {
            this.statistics = null;
            this.loading = false;
        }
    }
});
